module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8bdce73195bf475057ff606ab3f6fffb.png";